// Based on the work (c) 2023-present, Yiwen AI which is licensed under the MIT license:
// https://github.com/yiwen-ai/xid-ts/blob/main/src/index.ts

const encodedLen = 20; // string encoded len
const rawLen = 12; // binary raw len
const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();
const encoding = textEncoder.encode("0123456789abcdefghijklmnopqrstuv");

const cry: Crypto = crypto;
const start = getRandom3Bytes();

export class Xid extends Uint8Array {
  private static machineId = getRandom3Bytes();
  private static pid = getPid();
  // @ts-ignore
  private static counter = (start[0] << 16) | (start[1] << 8) | start[2];

  constructor() {
    super(rawLen);

    const view = new DataView(this.buffer);
    const timestamp = Math.floor(Date.now() / 1000);
    view.setUint32(0, timestamp);

    // @ts-ignore
    this[4] = Xid.machineId[0];
    // @ts-ignore
    this[5] = Xid.machineId[1];
    // @ts-ignore
    this[6] = Xid.machineId[2];
    this[7] = Xid.pid >> 8;
    this[8] = Xid.pid & 0x00ff;

    Xid.counter += 1;
    if (Xid.counter > 0xffffff) {
      Xid.counter = 0;
    }

    this[9] = Xid.counter >> 16;
    this[10] = (Xid.counter >> 8) & 0x00ff;
    this[11] = Xid.counter & 0x0000ff;
  }

  encode(): string {
    const dst = new Uint8Array(encodedLen);
    // @ts-ignore
    dst[19] = encoding[(this[11] << 4) & 0x1f];
    // @ts-ignore
    dst[18] = encoding[(this[11] >> 1) & 0x1f];
    // @ts-ignore
    dst[17] = encoding[(this[11] >> 6) | ((this[10] << 2) & 0x1f)];
    // @ts-ignore
    dst[16] = encoding[this[10] >> 3];
    // @ts-ignore
    dst[15] = encoding[this[9] & 0x1f];
    // @ts-ignore
    dst[14] = encoding[(this[9] >> 5) | ((this[8] << 3) & 0x1f)];
    // @ts-ignore
    dst[13] = encoding[(this[8] >> 2) & 0x1f];
    // @ts-ignore
    dst[12] = encoding[(this[8] >> 7) | ((this[7] << 1) & 0x1f)];
    // @ts-ignore
    dst[11] = encoding[(this[7] >> 4) | ((this[6] << 4) & 0x1f)];
    // @ts-ignore
    dst[10] = encoding[(this[6] >> 1) & 0x1f];
    // @ts-ignore
    dst[9] = encoding[(this[6] >> 6) | ((this[5] << 2) & 0x1f)];
    // @ts-ignore
    dst[8] = encoding[this[5] >> 3];
    // @ts-ignore
    dst[7] = encoding[this[4] & 0x1f];
    // @ts-ignore
    dst[6] = encoding[(this[4] >> 5) | ((this[3] << 3) & 0x1f)];
    // @ts-ignore
    dst[5] = encoding[(this[3] >> 2) & 0x1f];
    // @ts-ignore
    dst[4] = encoding[(this[3] >> 7) | ((this[2] << 1) & 0x1f)];
    // @ts-ignore
    dst[3] = encoding[(this[2] >> 4) | ((this[1] << 4) & 0x1f)];
    // @ts-ignore
    dst[2] = encoding[(this[1] >> 1) & 0x1f];
    // @ts-ignore
    dst[1] = encoding[(this[1] >> 6) | ((this[0] << 2) & 0x1f)];
    // @ts-ignore
    dst[0] = encoding[this[0] >> 3];

    return textDecoder.decode(dst);
  }

  toString(): string {
    return this.encode();
  }
}

function getRandom3Bytes(): Uint8Array {
  return cry.getRandomValues(new Uint8Array(3));
}

function getPid(): number {
  if (typeof process === "object" && process.pid > 0) {
    return process.pid & 0xffff;
  }

  const buf = cry.getRandomValues(new Uint8Array(2));
  // @ts-ignore
  return (buf[0] << 8) | buf[1];
}
